//@flow
import BaseTextField from '@material-ui/core/TextField';
import React from 'react';
import MaskedInput from 'react-text-mask';
import styled from 'styled-components';
import { purple, text } from '../style/colors';

export default ({
  type,
  error,
  ref,
  ...props
}: {
  type?: string,
  error?: any,
  props?: any,
  ref?: any,
}) => {
  let mask;
  if (type == 'tel') mask = PhoneMask;
  return (
    <TextField
      red={error ? 1 : 0}
      error={error}
      InputProps={{ inputComponent: mask }}
      {...props}
    />
  );
};
const hoverActiveColor = '#edf3ff';
const TextField = styled(BaseTextField)`
  && {
    color: ${text.primary};
    label {
      color: ${text.primary};
      font-size: 17px;
      font-weight: 400;
      text-transform: uppercase;
    }
    div {
      color: ${text.primary};

      input {
        cursor: pointer;
        color: ${text.primary};
        &:hover {
          background: ${hoverActiveColor};
        }
        &:focus {
          background: ${hoverActiveColor};
        }
      }
      textarea {
        cursor: pointer;
        color: ${text.primary};
        &:hover {
          background: ${hoverActiveColor};
        }
        &:focus {
          background: ${hoverActiveColor};
        }
      }
      &:after {
        background-color: ${purple[500]};
        ${props => props.error && 'background-color: #ff1744;'};
      }
    }
  }
`;

function PhoneMask(props) {
  return (
    <MaskedInput
      {...props}
      mask={[
        '(',
        /[1-9]/,
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={'\u2000'}
      // showMask
    />
  );
}
